module.exports = "/static-assets/_next/static/images/frog-love-b5ba0a8c671dbabc1e38b1efa29b9b81.svg";